const options = {
  5: "bg-red-400/5",
  10: "bg-red-400/10",
  25: "bg-red-400/25",
  50: "bg-red-400/50",
  75: "bg-red-400/75",
  90: "bg-red-400/90",
  100: "bg-red-400",
};

const from = {
  5: "from-red-400/5",
  10: "from-red-400/10",
  25: "from-red-400/25",
  50: "from-red-400/50",
  75: "from-red-400/75",
  90: "from-red-400/90",
  100: "from-red-400",
};

export default function getBackgroundRed400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
